import { __toESM } from "./chunk-fHKeL6sp.mjs";
import { require_monet } from "./monet-BwpF-dEg.mjs";
import { overloadEither_default } from "./overloadEither-CxBzmd1Y.mjs";
import { overloadMaybe_default } from "./overloadMaybe-DQw0qSQ4.mjs";

//#region src/monet.ts
var import_monet = /* @__PURE__ */ __toESM(require_monet());
/**
* @private
* @deprecated use fp-ts
*/
const { Maybe, Either, IO } = import_monet.default;
/**
* @private
* @deprecated use fp-ts
*
* @example
* ```ts twoslash
* import { Just } from '@simplisafe/ewok'
*
* const value = Just(42) // => Maybe<number> with value 42
* ```
*/
const Just = (value) => overloadMaybe_default(import_monet.default.Just(value));
/**
* @private
* @deprecated use fp-ts
*
* @example
* ```ts twoslash
* import { Some } from '@simplisafe/ewok'
*
* const value = Some(42) // => Maybe<number> with value 42
* ```
*/
const Some = (value) => overloadMaybe_default(import_monet.default.Some(value));
/**
* @private
* @deprecated use fp-ts
*
* @example
* ```ts twoslash
* import { None } from '@simplisafe/ewok'
*
* const empty = None<number>() // => Maybe<number> with no value
* ```
*/
const None = () => overloadMaybe_default(import_monet.default.None());
/**
* @private
* @deprecated use fp-ts
*
* @example
* ```ts twoslash
* import { Nothing } from '@simplisafe/ewok'
*
* const empty = Nothing<number>() // => Maybe<number> with no value
* ```
*/
const Nothing = () => overloadMaybe_default(import_monet.default.Nothing());
/**
* @private
* @deprecated use fp-ts
*
* @example
* ```ts twoslash
* import { Left } from '@simplisafe/ewok'
*
* const error = Left<string, number>('error') // => Either<string, number> with error
* ```
*/
const Left = (value) => overloadEither_default(import_monet.default.Left(value));
/**
* @private
* @deprecated use fp-ts
*
* @example
* ```ts twoslash
* import { Right } from '@simplisafe/ewok'
*
* const success = Right<string, number>(42) // => Either<string, number> with value 42
* ```
*/
const Right = (value) => overloadEither_default(import_monet.default.Right(value));

//#endregion
export { Either, IO, Just, Left, Maybe, None, Nothing, Right, Some };
//# sourceMappingURL=monet-CqDxra2t.mjs.map